module.exports = __webpack_public_path__ + "static/media/storage_fee.8702f9f0.png";